export const HANDLE_TOP_OFFSET_IN_PIXELS = 24;
export const NODE_WIDTH_IN_PIXELS = 240;
export const TYPICAL_BASE_NODE_HEIGHT_IN_PIXELS = 94;
